<template>
  <mint-modal-standalone v-if="isVisible" position="center" class="your-new-score-modal" data-qa="your-new-score-modal"
    @close="onCloseModal">
    <section>

      <h2 class="your-new-score-modal__title">Your new TransUnion credit score is here</h2>
      <p class="your-new-score-modal__description">
        TransUnion has updated how it calculates your Credit Score, so it's now out of <strong>999</strong> (rather than the old 710). So the score (and score band) you're in may have changed... but it's not something to worry about. Lenders mostly look at the information on your Credit Report when deciding whether to lend to you - and that won't have changed as part of this.
      </p>

      <img class="your-new-score-modal__image your-new-score-modal__image--base" src="@/assets/images/MSE-TU-NewScore-Mobile.png"
        alt="An app screen showing a credit score dial animating up to the maximum score of 999 out of 999" />
      <img class="your-new-score-modal__image your-new-score-modal__image--md" src="@/assets/images/MSE-TU-NewScore-Web.png"
        alt="An app screen showing a credit score dial animating up to the maximum score of 999 out of 999" />

      <MintButton class="your-new-score-modal__btn" data-qa="your-new-score-modal-button"
      @click="onCloseModal"
      >
        Got it
      </MintButton>
    </section>
  </mint-modal-standalone>
</template>

<script setup lang="ts">
import MintButton from '@mony-group/mint-button';
import { MintModalStandalone } from '@mony-group/mint-modal';
import { computed, ref, watch } from 'vue';

import { useCreditReport } from '@/stores';
const creditReportStore = useCreditReport();

const maxScore = computed(() => creditReportStore.fullCreditProfile?.maxScore);
const isScoreActive = computed(() => maxScore.value === 999);

const dismissedKey = 'yourNewScoreModalDismissed';
const isVisible = ref(false);

watch(isScoreActive, (isActive) => {
  isVisible.value = isActive && localStorage.getItem(dismissedKey) === null;
}, { immediate: true });

const onCloseModal = () => {
  localStorage.setItem(dismissedKey, 'true');
  isVisible.value = false;
};
</script>

<style lang="scss" scoped>
.your-new-score-modal {

  &__title {
    font-size: 1.25rem;
    margin-bottom: 1rem;

    @include new-md {
      font-size: 1.5625rem;
    }
  }

  &__description {
    font-size: 0.875rem;
    margin-bottom: 1rem;

    @include new-md {
      font-size: 1rem;
    }
  }

  &__image {
    width: 100%;
    margin-bottom: 1rem;

    &--base {
      display: block;

      @include new-md {
        display: none;
      }
    }

    &--md {
      display: none;

      @include new-md {
        display: block;
      }
    }
  }

  &__btn {
    padding: 0 0.5rem;
    margin-left: auto;
    width: 100%;

    span {
      text-align: center;
    }

    @include new-md {
      display: flex;
      margin-left: auto;
      width: auto;
    }

    &:deep(img) {
      background-color: white;
      border-radius: 4px;
      padding: 0.2rem;
    }
  }

  :global(.your-new-score-modal .mint-slider__dialog) {
    width: calc(100% - 1rem);
    max-width: 630px;
  }

  :global(.your-new-score-modal .mint-slider__close) {
    left: 0;
    top: 0;
  }

}
</style>